module.exports = __webpack_public_path__ + "img/send-back.385a622b.svg";